import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { PurchaseService } from '@schoolbelle/api/purchase';
import { FormControl, FormArray, FormGroup } from '@angular/forms';
import { Subscription, combineLatest } from 'rxjs';
import { startWith, distinctUntilChanged, map } from 'rxjs/operators';
import { join, get } from 'lodash-es';

@Component({
  selector: 'app-effective-range',
  templateUrl: './effective-range.component.html',
  styleUrls: ['./effective-range.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class EffectiveRangeComponent implements OnInit {
  @Input() disableStartingDate:boolean = false;
  @Input() allowCustomDate:boolean = true;
  @Input('form') form:FormGroup;
  products:FormArray;
  

  startsAt:FormControl;
  expiresAt:FormControl;
  months:FormControl;
  span:FormControl;
  paymentType:FormControl;
  
  maxDate:Date;

  /**
   * 2019.10.04 -> 2020.02.29
   * 
   * 2020.01.01 -> 2020.02.29
   * 
   * 2020.04.01 -> 2021.02.28
   */
  endOfSchoolYear:Date;
  howLong:'oneYear'|'tillEndOfSchoolYear' = 'oneYear';
  subscriptions = new Subscription();
  shouldExtend:boolean = false;


  constructor(
    private purchase:PurchaseService,
    private cdRef:ChangeDetectorRef,
  ) { 
  }

  ngOnInit(): void {
    this.products = this.form.get('products') as FormArray;
    this.months = this.form.get('months') as FormControl
    this.startsAt = this.form.get('startsAt') as FormControl;
    this.expiresAt = this.form.get('expiresAt') as FormControl
    this.paymentType = this.form.get('paymentType') as FormControl;

    const months = this.months.value;
    this.refreshEndOfSchoolYear();
    this.span = new FormControl(months === 12 ? '1year' : this.expiresAt.value === this.endOfSchoolYear.getTime() ? 'until_end_of_school_year' : null);

    this.subscriptions.add(
      combineLatest(
        this.span.valueChanges.pipe(startWith(this.span.value)),
        this.startsAt.valueChanges.pipe(startWith(this.startsAt.value)),
        this.expiresAt.valueChanges.pipe(startWith(this.expiresAt.value)),
        this.products.valueChanges.pipe(startWith(this.products.value),map(products=>{ return products.map(p=>p.productId).join(','); })),
        this.paymentType.valueChanges.pipe(startWith(this.paymentType.value)),
      )
      .pipe(
        distinctUntilChanged((x,y)=>{
          return join(x,'-') === join(y,'-')
        }),
        map(()=>{ 
          return [this.span.value, this.startsAt.value, this.expiresAt.value, this.products.value.map(p=>p.productIds).join(','), this.paymentType.value]; 
        }),
      )
      .subscribe(([span, starts_at, expires_at])=>{
        this.refreshEndOfSchoolYear();
        const max_date = this.refreshMaxDate();
        if (expires_at > max_date.getTime()) expires_at = max_date.getTime();
 

        if (span === '1year') {
          let expires_at_date = new Date(starts_at);
          expires_at_date.setFullYear(expires_at_date.getFullYear() + 1);
          expires_at = expires_at_date.getTime() - 1000;
        }
        else if (span === 'until_end_of_school_year') { // end of the second semester
          const end_of_school_year = this.endOfSchoolYear;
          expires_at = end_of_school_year.getTime();
        } 
        if (this.expiresAt.value !== expires_at) this.expiresAt.setValue(expires_at);
        const months =this.getNumberOfMonths();
        if (this.months.value !== months) this.months.setValue(months);


        // subscription type product 
        this.products.controls.forEach(productFormGroup=>{
          const product_id = get(productFormGroup.value, ['productId']);
          if (!product_id) return;
          const product_info = this.purchase.currentProducts.find(p=>p.product_id === product_id);
          if (!product_info) return;
          if (!product_info.expires) return;

          if (productFormGroup.get('startsAt').value !== starts_at) productFormGroup.get('startsAt').setValue(starts_at);   
          if (productFormGroup.get('expiresAt').value !== expires_at) productFormGroup.get('expiresAt').setValue(expires_at);   
          if (productFormGroup.get('amount').value !== months) productFormGroup.get('amount').setValue(months);
        });
        this.cdRef.detectChanges();
      })
    );  
  }

  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }
  private refreshMaxDate () {
    const paymentType = this.paymentType.value;
    const starts_at = this.startsAt.value;
    if (paymentType === 'virtualAccount') {

      this.maxDate = new Date(starts_at + 1 * 365 * 24 * 60 * 60 * 1000);
      // if (this.expiresAt.value > this.maxDate.getTime()) {
      //   this.expiresAt.setValue(this.maxDate.getTime());
      // }
    }
    else {
      this.maxDate = new Date(starts_at + 2 * 365 * 24 * 60 * 60 * 1000);
    } 
    return this.maxDate;

  }

  private refreshEndOfSchoolYear () {
    const paymentType = this.paymentType.value;
    const starts_at = this.startsAt.value ? new Date(this.startsAt.value) : new Date();
    const end_of_school_year_in_current_year = this.getLastDayOfFebOfYear(starts_at);
    const end_of_school_year_in_next_year = this.getLastDayOfFebOfYear(starts_at, 1);
    const diff = this.getNumberOfDiffInMonths(starts_at, end_of_school_year_in_current_year);
    if (
      paymentType === 'virtualAccount' ||
      (end_of_school_year_in_current_year > starts_at && diff >= 3)
    ) {
      this.endOfSchoolYear = end_of_school_year_in_current_year;
    }
    else {
      this.endOfSchoolYear = end_of_school_year_in_next_year;
    }

  }
  private getLastDayOfFebOfYear (from_date:Date, diff_from_now_in_year:number = 0) {
    const date = new Date(from_date.getTime());
    date.setFullYear(date.getFullYear() + diff_from_now_in_year);
    date.setMonth(2, 1);
    date.setHours(0,0,-1,0);
    return date;
  }

  /**
   * ceil
   */
  getNumberOfMonths ():number {
    const date1:Date = new Date(this.startsAt.value);
    const date2:Date = new Date(this.expiresAt.value);
    return this.getNumberOfDiffInMonths(date1, date2);
  }
  /**
   * 
   * @param date1 early date
   * @param date2 late date
   */
  private getNumberOfDiffInMonths(date1:Date, date2:Date) {
    let diff = 0;
    diff += 12 * (date2.getFullYear() - date1.getFullYear());
    diff += date2.getMonth() - date1.getMonth();

    //ceil 
    if (date2.getDate() > date1.getDate()) diff ++;
    //ceil 
    return diff;

  }
}
